import { ReactNode } from 'react'

type Size = 'sm' | 'md' | 'lg' | 'xl'

const widths: Record<Size, string> = {
  sm: 'max-w-3xl',
  md: 'max-w-5xl',
  lg: 'max-w-6xl',
  xl: 'max-w-7xl',
}

interface ContainerProps {
  children: ReactNode
  size?: Size
  className?: string
}

export default function Container({
  children,
  size = 'lg',
  className = '',
}: ContainerProps) {
  return (
    <div className={`mx-auto w-full px-6 lg:px-8 ${widths[size]} ${className}`}>
      {children}
    </div>
  )
}
